var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "13px",
    viewBox: "0 0 15 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Trazado_1499") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ordenes",
    transform: "translate(-168.000000, -134.000200)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Back-2",
    transform: "translate(161.000000, 125.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0950508,15.3336877 C21.0950508,15.7940761 20.7218367,16.1672898 20.2614513,16.1672898 L10.607774,16.1672898 L14.1857578,19.7437277 C14.396548,19.9545178 14.4788723,20.2617558 14.4017189,20.5497023 C14.3245627,20.8376475 14.0996488,21.0625623 13.8117029,21.1397177 C13.5237537,21.2168746 13.2165188,21.1345498 13.0057257,20.9237539 L8.00644671,15.923704 C7.84976722,15.7673267 7.7617188,15.5550559 7.7617188,15.3336877 C7.7617188,15.1123258 7.84976722,14.9000492 8.00644671,14.7436719 L13.0057257,9.74439455 C13.3315449,9.41857546 13.8597822,9.41853121 14.1856576,9.74429133 C14.5115301,10.0700514 14.5116684,10.5982917 14.1859644,10.9242201 L10.607774,14.5000856 L20.2622238,14.5000856 C20.7223055,14.5005164 21.0950508,14.8736069 21.0950508,15.3336877 L21.0950508,15.3336877 Z",
    id: "Trazado_1499"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.be89c4619d5b524e247b186d3e2ee766.svg";
export { ForwardRef as ReactComponent };